import React, { useState } from "react";
import {
    Cart,
    Language,
    Category,
    PhoneHeader,
    EmailHeader,
    SearchHeader
} from "../../assets/icons/icons";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import CategoriesMenu from "../sections/CategoriesMenu";
import { useEffect, useRef } from "react";
import LangRes from "../sections/LangRes";
import SearchSection from "../sections/SearchSection";
export default function Header() {
    const { t, i18n } = useTranslation();
    const [isOpenLanguage, setIsOpenLanguage] = useState(false);
    const dropdownRef = useRef(null);

    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsScrolled(scrollTop > 50);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpenLanguage(false);
    };

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenLanguage(false);
            }
        };


        document.addEventListener('click', handleClickOutside);


        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {

        i18n.on('languageChanged', (lng) => {
            document.documentElement.lang = lng;
            document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        });
    }, [i18n]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenLanguage(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <header className={`shadow-custom top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'fixed bg-white w-full shadow-lg' : 'bg-transparent text-black'
            }`}>
            <div className="d-none py-[10px] bg-[#F5F5F5]">
                <div className="container flex items-center justify-between">
                    <div className="d-none flex items-center gap-[5px]">
                        <Link to={"https://www.facebook.com/people/AJ-Mart/61573171957943/"}>
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/facebook.svg").default} alt="Facebook" />
                        </Link>
                        <Link to={"https://www.instagram.com/aj_mart.jo/?hl=en"}>
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/instagram.svg").default} alt="Instagram" />
                        </Link>
                        <Link to={"https://wa.link/ppk1jv"}>
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/Whatsapp.svg").default} alt="Whatsapp" />
                        </Link>
                    </div>
                    <div className="flex items-center gap-[10px] font-15">
                   <Link to={"mailto:info@aj-mart.com"} className="flex items-center gap-[3px]">
                        <EmailHeader />
                        <span dir="ltr" className="inline-block">info@aj-mart.com</span>
                        </Link>

                        <Link to={"tel:+962790773377"} className="flex items-center gap-[3px]">
                        <PhoneHeader />
                        <span dir="ltr" className="inline-block">+962 79 077 3377</span>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="bg-[#F5F5F5] h-[2px]"></div>
            <div className="container flex items-center justify-between py-[20px]">
                <Link to={"/"}>
                    <img className="w-[125px]" src={require("../../assets/logo/logo.svg").default} alt="Logo" />
                </Link>

                <div className="d-none relative">
                    <div className="right-none-left w-fit absolute bottom-[13px] left-[9px]"> <SearchHeader /></div>
                    <input type="search" placeholder={t("Search Product")} className="rounded-[7px] w-[450px] py-[9px] px-[35px] bg-[#f5f5f5] border-0 outline-0 shadow-[0px_0px_10px_#00000024]" />
                </div>

                <div className="d-none flex gap-4 items-center">
                    <Link className="flex items-center gap-[3px]" to={""}>
                        <Category />
                        <CategoriesMenu />
                    </Link>
                    <Link className="flex items-center text-[#666666] font-bold gap-[3px]" to={"/cart"}>
                        <Cart />
                        <span>{t("Cart")}</span>
                    </Link>


                    <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => setIsOpenLanguage(!isOpenLanguage)}
                            className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md "
                        >
                            <Language />
                            <span>{t("Language")}</span>
                        </button>
                        {isOpenLanguage && (
                            <div className="absolute z-1000 right-0 mt-2 w-40 bg-white shadow-lg rounded-md" style={{zIndex: "1000"}}>
                                <div className="py-1">
                                    <button
                                        onClick={() => changeLanguage('en')}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                                    >
                                        English
                                    </button>
                                    <button
                                        onClick={() => changeLanguage('ar')}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                                    >
                                        العربية
                                    </button>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
                <div className="dis-none flex items-center gap-[5px]">
                    <div className="flex items-center gap-[5px]">
                        <SearchSection/>
                        <Link className="flex items-center text-[#666666] font-bold gap-[3px]" to={"/cart"}>
                            <Cart />
                        </Link>
                        <LangRes />
                        <Link to={"/category"}>
                            <Category />
                        </Link>
                    </div>
                </div>
            </div>


        </header>
    );
}
